<template>
  <NuxtLink
    class="flex flex-col justify-between p-0 bg-surface-action-2 rounded-md border-sm border-border-tertiary shadow-card overflow-hidden relative no-underline h-full test--product-item focus-rounded hover:bg-surface-action-hover"
    :to="cardLink"
    external
    :data-testid="['productList', cardData?.product.ProductName].join('_')"
    @click="filterStore.selectedProduct = cardData"
  >
    <div class="p-16">
      <div v-if="urgencyText" class="absolute top-8 right-8 z-10">
        <AppLabel
          color="few-left"
          :text="urgencyText"
          line-height="leading-none"
        />
      </div>

      <ProductcardImages
        :card-data="cardData"
        :condition="condition"
        :card-index="cardIndex"
      />

      <ProductcardColorIndicators
        :colors="cardData?.colors"
        :product-id="cardData?.product.ProductId"
      />

      <div class="mb-8 md:mb-12">
        <p class="body-md">
          {{ cardData?.product?.ManufacturerName }}
        </p>
        <h2 class="heading-xxs">
          {{ cardData?.product?.ProductName }}
        </h2>

        <ProductcardPlanTextString
          v-if="cardData?.bundlePrice?.Plan"
          :plan="cardData?.bundlePrice?.Plan"
        />
        <ProductcardColorsTextForSR :colors="cardData?.colors" />

        <div v-if="bottomCampaignLabels.length > 0" class="flex flex-col gap-4">
          <AppLabel
            v-for="label in bottomCampaignLabels.slice(0, 2)"
            :key="label.Text + label.Color"
            :color="label.Color"
            :text="label.Text"
            :aria-label="`Kampanj: ${label.Text}.`"
          />
        </div>

        <ProductcardConditionTextForSR :condition="condition" />
      </div>
    </div>

    <ProductcardAccessoryPriceText
      v-if="cardData?.variant?.Prices?.Price"
      :card-data="cardData"
    />

    <ProductcardPhoneDirectPaymentPriceText
      v-else-if="cardData?.payment?.Time === 1"
      :card-data="cardData"
    />

    <ProductcardPhoneMonthlyPrice v-else :card-data="cardData" />

    <p hidden class="test--product-item-condition">
      {{ condition?.toLocaleLowerCase() }}
    </p>
  </NuxtLink>
</template>

<script lang="ts" setup>
import type { LabelDto } from '~/models/ListingProduct.api.model';

const filterStore = useFilterStore();

const props = defineProps<{
  cardData?: ProductCard;
  cardIndex: number;
}>();

const condition = props.cardData?.variant.Condition;

const cardLink = computed(() => props.cardData?.product?.ProductLinkUrl ?? '');

const urgencyText = computed(() => {
  return (
    props.cardData?.bundlePrice?.Urgency ||
    props.cardData?.variant?.Prices?.Price?.Urgency ||
    undefined
  );
});

const bottomCampaignLabels = computed(() => {
  const phoneVariantLabels = props.cardData?.bundlePrice?.Labels;
  const accessoryVariantCampaignLabels =
    props.cardData?.variant.Prices?.Price?.Labels;
  const accessoryProductManualLabel = props.cardData?.variant.Prices?.Label;

  if (phoneVariantLabels && phoneVariantLabels.length > 0) {
    return phoneVariantLabels;
  }

  const accessoryLabels: LabelDto[] = [];

  if (accessoryProductManualLabel) {
    accessoryLabels.push(accessoryProductManualLabel);
  }

  if (
    accessoryVariantCampaignLabels &&
    accessoryVariantCampaignLabels.length > 0
  ) {
    accessoryVariantCampaignLabels.forEach((label) =>
      accessoryLabels.push(label),
    );
  }

  return accessoryLabels;
});
</script>

<style></style>
